//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DiscordPreFlightCheck from 'core/components/discord-pre-flight-check.vue'
import TwitchPreFlightCheck from 'core/components/twitch-pre-flight-check.vue'

export default {
    name: 'CozyCommunityInfo',

    methods: {
        goTwitch() {
            this.$present(TwitchPreFlightCheck)
            this.trackJoin('twitch::leah')
        },

        goDiscord() {
            this.$present(DiscordPreFlightCheck)
            this.trackJoin('discord')
        },

        trackJoin(category) {
            this.$gtag.event(`cozy-join-${category}`)
        },
    },
}
